import messages_ja from "./locales/ja.json";

export const locale = navigator.language.split(/[-_]/)[0];

export function LocaleMessage(): Record<string, string> {
  return messages_ja;
}

export { default } from './msgId';
